import React, { useState } from 'react';
import Table from '../../components/tables/Table';
import { getKitAssemblyView, getKitInventoryView } from '../../services/inventory';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { CustomCard } from '../../components/cards/CustomCard';
import { Edit } from 'lucide-react';
import { Link } from 'react-router-dom';

const KitAssemblyDetailedView = ({ kit, forProduct = false }) => {
    const [assemblyHistory, setAssemblyHistory] = useState([]);

    useEffect(() => {
        fetchAssemblyHistoryData({ query: `?kit_id=${kit.id}` });
    }, [kit, forProduct]);

    const fetchAssemblyHistoryData = async ({ query = "" }) => {
        const res = await getKitAssemblyView(`${query}`);
        if (res.status === 200) {
            setAssemblyHistory(res.data);
        } else {
            toast.error(res.data);
        }
    };

    const getStatusBadge = (status) => {
        const baseClasses = "px-2 py-1 rounded-full text-xs font-medium";
        switch (status) {
            case 'active':
                return `${baseClasses} bg-green-100 text-green-800`;
            case 'inactive':
                return `${baseClasses} bg-gray-100 text-gray-800`;
            case 'completed':
                return `${baseClasses} bg-blue-100 text-blue-800`;
            case 'in_progress':
                return `${baseClasses} bg-yellow-100 text-yellow-800`;
            default:
                return `${baseClasses} bg-gray-100 text-gray-800`;
        }
    };

    return (
        <div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                    <h3 className="text-lg font-semibold mb-2">{kit.name}</h3>
                    <p className="text-gray-600 mb-2">SKU: {kit.sku}</p>
                    <p className="text-gray-600 mb-4">{kit.description}</p>

                    <div className="space-y-2">
                        <p><span className="font-semibold">Product:</span> {kit.product} units</p>
                        <p><span className="font-semibold">Total kits created:</span> {kit.quantity} units</p>
                        <p><span className="font-semibold">Product Stock:</span> {kit.product_stock} units</p>
                        <p>
                            <span className="font-semibold">Status:</span>
                            <span className={`ml-2 ${getStatusBadge(kit.status)}`}>
                                {kit.status.charAt(0).toUpperCase() + kit.status.slice(1)}
                            </span>
                        </p>
                    </div>
                </div>

                {
                    !forProduct &&
                    <div>
                        <h4 className="font-semibold mb-3">Components Required</h4>
                        <div className="space-y-2">
                            {kit.kit_components.map((component, index) => (
                                <div className="flex flex-col p-2 bg-gray-50 rounded">
                                    <span className="text-sm">{component?.raw_material?.name}</span>
                                    <span className="text-xs text-gray-500">~ Raw Material Quantity: {component.raw_material_quantity} {component.unit}</span>
                                    <hr className="my-0.5 mx-1" />
                                    <div className="flex flex-row gap-2">
                                        <div className="flex flex-col flex-1">
                                            <span className="text-sm">
                                                Quatity
                                            </span>
                                            <span className="text-sm font-semibold">
                                                {component.quantity}
                                            </span>
                                        </div>
                                        <div className="flex flex-col flex-1">
                                            <span className="text-sm">
                                                Raw Material Quantity
                                            </span>
                                            <div className="flex flex-row items-center gap-2">
                                                <span className="text-sm font-semibold">
                                                    {component.raw_material.quantity}
                                                </span>
                                                <Link
                                                    to={`/inventory/raw-items/edit`}
                                                    state={{ item: component.raw_material }}
                                                >
                                                    <Edit className="text-primary cursor-pointer text-xl" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                }
            </div>

            <CustomCard title={forProduct ? 'Recent Product Activity' : 'Recent Assembly Activity'}>
                <Table
                    headers={[
                        { label: "Kit", key: "kit" },
                        { label: "Quantity", key: "quantity" },
                        { label: forProduct ? 'Updated By' : 'Assembled By', key: "assembler" },
                        { label: "Date & Time", key: "date" },
                        { label: "Status", key: "status" }
                    ]}
                    rows={assemblyHistory.results?.map((activity) => ({
                        kit: <p className="font-medium">{activity.kit}</p>,
                        quantity: <span className="font-semibold">{activity.quantity} units</span>,
                        assembler: activity.added_by,
                        date: new Date(activity.created_at).toLocaleString(),
                        status: (
                            <span className={getStatusBadge("assembled")}>
                                {forProduct ? 'Updated' : 'Assembled'}
                            </span>
                        )
                    }))}
                />
            </CustomCard>
        </div>
    );
};

export default KitAssemblyDetailedView; 